module.exports = __webpack_public_path__ + "media/images/city/094-sydney-opera-house-c386856582039cd61a914df22f3067b7.svg";